<template>
	<transition name="bounce" type="animation" @before-enter="pauseTimers">
		<div class="popup-holder" v-once>
			<div class="popup">
				<img src="@assets/img/logo-sm.svg" class="logo" />
				<h2 class="heading">{{ ui.heading }}</h2>
				<div class="content" v-html="ui.content"></div>
				<ul class="links">
					<LinkHandler
						class="link-item"
						v-for="fields in ui.links"
						:key="fields.link.title"
						:url="fields.link.url"
						:title="fields.link.title"
					/>
				</ul>
				<Button class="resume-btn" :action="close">{{ ui.close_button_text }}</Button>
			</div>
		</div>
	</transition>
</template>

<script>
import AnimatedNumber from '@/components/abstract/AnimatedNumber';
import Button from '@/components/abstract/Button';
import LinkHandler from '@/components/abstract/LinkHandler';
import { mapState, mapActions } from 'vuex';

export default {
	name: 'CycleSummary',
	props: ["stage"],
	components: {
		AnimatedNumber,
		Button,
		LinkHandler,
	},
	computed: {
		...mapState({
			ui: state => state.config.ui.info_box,
		}),
	},
	methods: {
		...mapActions([
			"pauseTimers",
			"unpauseTimers",
		]),
		close() {
			this.unpauseTimers();
			this.$emit("close");
		},
	},
};
</script>

<style lang="scss" scoped>
	.popup {
		padding: 4em 3em;
		max-width: 775px;

		@include mobile { padding: 8vh 5vw; }
	}

	.logo {
		width: 33.33%;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.heading { text-align: center; }

	.links {
		display: flex;
		justify-content: center;
		padding: 0;
		margin: 0;

		@include mobile { flex-wrap: wrap; }
	}

	.link-item {
		list-style: none;
		color: #fff;
		line-height: 1;

		&:not(:first-child) {
			border-left: 1px solid;
			margin-left: .5em;
			padding-left: .5em;
		}

		& /deep/ a {
			text-decoration: none;
			white-space: nowrap;
			color: $brand-color-primary-extra-light;
		}


		@include mobile {
			margin-top: .5em;
			margin-bottom: .5em;

			&:nth-child(2n+3) {
				border-left: 0;
				margin-left: 0;
				padding-left: 0;
			}
		}
	}

	.resume-btn {
		display: block;
		transform: translate(-50%, -50%);
		margin: 0 auto;
		position: absolute;
		top: 100%;
		left: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/InfoBox.vue